"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lru_cache_1 = __importDefault(require("lru-cache"));
var cacheOptions = {
    max: 100,
    maxAge: 24 * 1000 * 60 * 60
};
var LruCache = (function () {
    function LruCache(option) {
        if (option === void 0) { option = cacheOptions; }
        this.cache = new lru_cache_1.default(option);
    }
    LruCache.prototype.getIp = function (ip) {
        return this.cache.get(ip);
    };
    LruCache.prototype.getAsn = function (asn) {
        return this.cache.get(asn);
    };
    LruCache.prototype.setIp = function (ip, data) {
        this.cache.set(ip, data);
    };
    LruCache.prototype.setAsn = function (asn, data) {
        this.cache.set(asn, data);
    };
    return LruCache;
}());
exports.default = LruCache;
